export default "__VITE_ASSET__Cl7dzxTH__"